import React from 'react';
import { TextField } from '@mui/material';
import { func, string } from 'prop-types';
import { useIntl } from 'react-intl';
import useStyles from './Input.styles';
import { AUTO_COMPLETE } from '../../../../constants/constants';

/**
 * Email input for the create user form (step 2).
 * e.g. email="teacher@example.com"
 */
const EmailField = ({ email, handleChange, handleBlur, errorMessageId }) => {
  const { classes } = useStyles();
  const { formatMessage } = useIntl();

  return (
    <TextField
      value={email}
      error={Boolean(errorMessageId)}
      helperText={errorMessageId ? formatMessage({ id: errorMessageId }) : ''}
      onChange={handleChange}
      onBlur={handleBlur}
      inputProps={{ className: classes.input, 'data-testid': 'email' }}
      label={formatMessage({ id: 'earlyAccess.createUser.label.email' })}
      id="email"
      name="email"
      type="email"
      required
      autoComplete={AUTO_COMPLETE.EMAIL}
    />
  );
};

EmailField.propTypes = {
  email: string.isRequired,
  handleChange: func.isRequired,
  handleBlur: func.isRequired,
  errorMessageId: string,
};

export default EmailField;
